<template>
  <div class="chatGroup">
    <div class="edit-area">
      <h2 class="normal">猩号空间管理</h2>
      <div class="normal">
        空间名称：
        <div class="inputBox"><el-input v-model="name"></el-input></div>
      </div>
      <div class="normal">
        空间类别：
        <div class="inputBox">
          <el-select size="small" v-model="type">
            <el-option
              v-for="item in geoTypes"
              :key="item.key"
              :value="item.key"
              :label="item.label"
            ></el-option>
          </el-select>
        </div>
      </div>

      <el-button type="primary" @click="upToDb">保存</el-button>
    </div>

    <div id="real_container" :style="mapHeight">
      <div class="map-botton">
        <div class="showNear" @click="showNearChats">查看周边</div>

        <select v-model="currentCity" @change="changeCity">
          <option
            :value="item"
            v-for="(item, index) in cityList"
            :key="index"
            >{{ item }}</option
          >
        </select>

        <select v-model="district" @change="drawDistrict">
          <option :value="item" v-for="(item, index) in areas" :key="index">{{
            item
          }}</option>
        </select>
      </div>
      <el-amap-search-box
        class="search-box"
        :search-option="searchOption"
        :on-search-result="onSearchResult"
      >
      </el-amap-search-box>
      <el-amap
        class="amap-box"
        vid="real_map"
        ref="real_map"
        :zoom="zoom"
        :center="center"
        :amap-manager="amapManager"
        :plugin="plugin"
        :events="events"
      >
        <el-amap-marker
          v-if="markers.length > 0"
          vid="real_search_marker"
          :position="markers"
        ></el-amap-marker>
        <el-amap-marker
          vid="lnglat_marker"
          v-if="lnglat"
          :position="lnglat.split('|')"
          icon="./../../static/images/marker1.png"
        >
          <!-- 新增或修改地段的点标记 -->
        </el-amap-marker>

        <el-amap-marker
          :vid="'boundary' + index"
          v-for="(pos, index) in boundary"
          :key="'boundary' + index"
          draggable="true"
          :events="boundaryEvents"
          :position="pos"
          :offset="[-16, -27]"
          icon="./../../static/images/marker.png"
        >
          <!-- 边界 -->
        </el-amap-marker>
        <el-amap-polyline
          editable="false"
          :path="boundaryPath"
          strokeColor="blue"
          strokeWeight="2"
        ></el-amap-polyline>

        <el-amap-marker
          :vid="'near_chats' + index"
          v-for="(item, index) in nearChats"
          :key="'near_chats' + index"
          draggable="true"
          :events="nearMarkerEvents"
          :position="item.center.coordinates"
          :label="{ content: item.name, offset: [10, 12] }"
          :icon="
            item.hasBoundary
              ? './../../static/images/marker4.png'
              : './../../static/images/otherList.png'
          "
        >
        </el-amap-marker>
        <el-amap-polyline
          v-for="(item, index) in nearCircle"
          :key="'nearline' + index"
          editable="false"
          :path="item"
          strokeColor="#007eef"
          strokeWeight="2"
        ></el-amap-polyline>

        <el-amap-marker
          :vid="'area_chats' + index"
          v-for="(item, index) in areaChats"
          :key="'area_chats' + index"
          draggable="true"
          :position="item.center.coordinates"
          :label="{ content: item.name, offset: [10, 12] }"
          icon="./../../static/images/notdb.png"
        >
        </el-amap-marker>
        <el-amap-polyline
          v-for="(item, index) in areaChats"
          :key="'polyline' + index"
          editable="false"
          :path="item.boundary.coordinates"
          strokeColor="black"
          strokeWeight="2"
        ></el-amap-polyline>

        <el-amap-marker
          :vid="'district_marker' + index"
          v-for="(item, index) in districtPoints"
          :key="'district_marker' + index"
          draggable="true"
          :position="item.center"
          :label="{ content: item.name, offset: [10, 12] }"
          icon="./../../static/images/marker6.png"
        >
        </el-amap-marker>
      </el-amap>
    </div>
  </div>
</template>

<script>
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();

export default {
  data() {
    return {
      cityList: ["杭州", "上海", "广州", "深圳", "成都", "苏州"],
      currentCity: "",
      citycode: "",
      mapHeight: {},
      searchOption: {
        city: "杭州",
        citylimit: true
      },
      zoom: 15,
      center: [120.051238, 30.228232],
      // center: [121.473667,31.230525], // 上海
      amapManager,
      events: {
        complete: () => {
          let that = this;
          let currentMap = amapManager.getMap();
          that.currentMap = currentMap;
          console.log("加载完成");
        },
        click: e => {
          console.log("点击地图");
          let that = this;
          that.lnglat = e.lnglat.lng + "|" + e.lnglat.lat;
        },
        rightclick: e => {
          console.log("点击地图");
          let that = this;
          that.boundary.push([e.lnglat.lng, e.lnglat.lat]);
        }
      },
      plugin: [
        {
          //地图类型，卫星地图和普通地图
          pName: "MapType",
          defaultType: 0
        }
      ],
      markers: "",
      boundaryEvents: {
        rightclick: e => {
          let that = this;
          that.boundary.splice(e.target.w.vid.replace("boundary", ""), 1);
        },
        dragging: e => {
          let that = this;
          let index = e.target.w.vid.replace("boundary", "");
          let dot = [e.lnglat.lng, e.lnglat.lat];
          that.boundary.splice(index, 1, dot);
        }
      },
      nearMarkerEvents: {
        click: e => {
          let that = this;
          let index = e.target.w.vid.replace("near_chats", "");
          let item = that.nearChats[index];
          that
            .$confirm(`确定编辑"${item.name}"?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(res => {
              that.init(item.id);
            })
            .catch(err => {
              console.log("取消");
            });
        },
        rightclick: e => {
          let that = this;
          let index = e.target.w.vid.replace("near_chats", "");
          let item = that.nearChats[index];
          that
            .$confirm(`确定删除"${item.name}"?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(res => {
              that.$axios
                .get(that.$url_prefix + "deleteOneGeo", {
                  params: {
                    geo_id: item.id
                  }
                })
                .then(res => {
                  that.nearChats.splice(index, 1);
                })
                .catch(err => {
                  console.log("delete err", err);
                });
            })
            .catch(err => {
              console.log("取消");
            });
        }
      },

      boundary: [], // 边界，范围
      lnglat: "", // 中心点
      name: "", // 群名称
      type: "", // 群类别
      chat_id: "", // 群id
      nearChats: [],
      nearCircle: [],

      areaChats: [],
      district: "",
      areas: [],
      geoTypes: [
        {
          key: 1,
          label: "学校"
        },
        {
          key: 2,
          label: "小区"
        },
        {
          key: 3,
          label: "办公"
        },
        {
          key: 4,
          label: "医院"
        },
        {
          key: 5,
          label: "商场"
        },
        {
          key: 6,
          label: "景观"
        },
        {
          key: 7,
          label: "交通"
        },
        {
          key: 8,
          label: "公建"
        }
      ],
      districtPoints: []
    };
  },
  created() {
    let height = window.innerHeight + "px";
    this.mapHeight.height = height;
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    if (from.name === "login") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      let origin = this.$options.data();
      delete origin.mapHeight;
      delete origin.events;
      delete origin.boundaryEvents;
      delete origin.nearMarkerEvents;
      Object.assign(this.$data, origin);
      this.init();
      // this.loadDistricts();
    }
    this.$route.meta.isBack = false;
  },
  methods: {
    init(geo_id) {
      let that = this;
      let obj = that.$route.params;
      geo_id = geo_id || obj.id;
      if (geo_id) {
        that.$axios
          .post(that.$url_prefix + "queryOneData", {
            match: {
              id: geo_id
            },
            db: "GeoGroupModel",
            projection: "id name type boundary center"
          })
          .then(function(res) {
            let data = res.data.data;
            that.boundary = (data.boundary && data.boundary.coordinates) || [];
            let center = data.center && data.center.coordinates;
            let lnglat = "";
            if (center && center.length) {
              lnglat = center.join("|");
              that.center = center;
            }
            that.lnglat = lnglat;
            that.name = data.name;
            that.type = data.type;
            that.chat_id = data.id;
          })
          .catch(function(res) {
            console.log("err", res);
            that.$message.error("查询失败，请检查网络");
          });
      }
    },
    loadDistricts() {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "queryOneData", {
          match: {
            id: "btybs3cxpu"
          },
          db: "WpBackupModel"
        })
        .then(res => {
          let data = JSON.parse(res.data.data.data);
          let points = [];
          let currentMap = amapManager.getMap();
          data.forEach(x => {
            points.push({
              name: x.area_name,
              center: x.center.split("|")
            });
            let fillOpacity = 0;
            let overDistricts = [
              "杨浦区",
              "长宁区",
              "静安区",
              "黄浦区",
              "闵行区",
              "金山区",
              "奉贤区",
              "宝山区",
              "虹口区",
              "浦东新区",
              "嘉定区",
              "崇明区"
            ];
            if (overDistricts.includes(x.area_name)) {
              fillOpacity = 0.5;
            }
            x.dots.forEach(y => {
              let polygon = new AMap.Polygon({
                path: y,
                fillOpacity: fillOpacity,
                bubble: true,
                fillColor: "#ff0000",
                strokeWeight: 1,
                strokeOpacity: 1,
                strokeColor: "#CC66CC"
              });
              currentMap.add(polygon);
            });
          });
          that.districtPoints = points;
        });
    },

    onSearchResult(pois) {
      // 地图搜索
      if (pois.length > 0) {
        let { lng, lat } = pois[0];
        this.markers = [lng, lat];
        this.center = [lng, lat];
      }
    },

    changeCity() {
      let that = this;
      that.searchOption.city = that.currentCity;
      new AMap.DistrictSearch({
        subdistrict: 1, //返回下一级行政区
        level: "city" //查询行政级别为 市
      }).search(that.currentCity, (status, result) => {
        result.districtList.sort((a, b) => {
          return b.districtList.length - a.districtList.length;
        });
        let center = result.districtList[0].center;
        that.center = [center.lng, center.lat];
        that.areas = result.districtList[0].districtList.map(x => x.name);
        that.citycode = result.districtList[0].citycode;
      });
    },

    upToDb() {
      let that = this;
      let name = that.name.trim();
      let type = Number(that.type);
      if (!name) {
        that.$message.error("请填写群名称");
        return;
      }
      if (!type) {
        that.$message.error("请填写群类别");
        return;
      }
      if (!that.lnglat) {
        that.$message.error("请标记中心点");
        return;
      }
      if (!that.boundary.length) {
        that.$message.error("请标记边界");
        return;
      }
      if (!that.currentCity) {
        that.$message.error("请选择城市");
        return;
      }

      let obj = {
        city: that.currentCity,
        name: name,
        type: type,
        center: {
          type: "Point",
          coordinates: that.lnglat.split("|").map(x => Number(x))
        },
        boundary: {
          type: "Polygon",
          coordinates: that.boundary
        }
      };
      if (that.chat_id) {
        obj.id = that.chat_id;
      }
      let param = {
        db: "GeoGroupModel",
        model: "edit",
        item: JSON.stringify(obj)
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function(res) {
          let obj = res.data.data;
          let district = obj.district;
          if (district && district === that.district) {
            if (that.areaChats.length) {
              let temp = obj.boundary.coordinates;
              temp.push(temp[0]);
              that.areaChats.push(obj);
            }
          }
          that.chat_id = "";
          that.boundary = [];
          that.lnglat = "";
          that.chat_id = "";
          that.name = "";
        })
        .catch(function(err) {
          that.$message.error("保存失败");
          console.log("err", err);
        });
    },

    showNearChats() {
      let that = this;
      if (that.lnglat) {
        that.$open();
        that.$axios
          .post(that.$url_prefix + "getNearChatGroup", {
            city: that.currentCity,
            center: that.lnglat.split("|").map(x => Number(x))
          })
          .then(res => {
            that.$close();
            let list = res.data.data.filter(x => x.id !== that.chat_id);
            if (list.length === 0) {
              that.$message.error("附近没有空间");
            }
            let nearCircle = [];
            list.forEach(x => {
              let temp = x.boundary && x.boundary.coordinates;
              if (temp && temp.length) {
                x.hasBoundary = true;
                temp.push(temp[0]);
                nearCircle.push(temp);
              }
              delete x.boundary;
            });
            that.nearChats = list;
            that.nearCircle = nearCircle;
          })
          .catch(err => {
            that.$close();
            that.$message.error("查询出错");
            console.log("getNearChats err", err);
          });
      } else {
        that.$message.error("没有中心点");
      }
    },

    showAreaChats() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "drawChatGroup", {
          params: {
            district: that.district
          }
        })
        .then(res => {
          that.$close();
          let list = res.data.data.filter(x => {
            return (
              x.center &&
              x.center.coordinates &&
              x.center.coordinates.length &&
              x.boundary &&
              x.boundary.coordinates &&
              x.boundary.coordinates.length
            );
          });
          list.forEach(x => {
            let temp = x.boundary.coordinates;
            temp.push(temp[0]);
          });
          that.areaChats = list;
        })
        .catch(err => {
          that.$close();
          console.log("err", err);
        });
    },

    drawDistrict() {
      let that = this;
      let currentMap = that.amapManager.getMap();
      if (that.disPolygon) currentMap.remove(that.disPolygon);
      new AMap.DistrictSearch({
        subdistrict: 0, //返回下一级行政区
        extensions: "all", //返回行政区边界坐标组等具体信息
        level: "district" //查询行政级别为 市
      }).search(that.district, (status, result) => {
        let list = result.districtList.filter(x => x.citycode === that.citycode);
        let boundaries = list[0].boundaries
        boundaries.sort((a, b) => b.length - a.length);
        let polygon = new AMap.Polyline({
          vid: that.district,
          zIndex: 500,
          path: boundaries[0].map(item => [item.lng, item.lat]),
          borderWeight: 1, // 线条宽度，默认为 1
          strokeColor: "black" // 线条颜色
        });
        that.disPolygon = polygon;
        polygon.setMap(currentMap);
      });
    }
  },
  computed: {
    boundaryPath() {
      let result = this.boundary.slice();
      if (result.length > 3) {
        result.push(result[0]);
      }
      return result;
    }
  }
};
</script>

<style scoped>
.chatGroup {
  display: flex;
  width: 100%;
  font-family: "Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS",
    sans-serif;
}

.chatGroup .edit-area {
  text-align: center;
  width: 20%;
  overflow: hidden;
}

.chatGroup #real_container {
  width: 80%;
  position: relative;
}

#real_container .search-box {
  position: absolute;
  left: 0;
  top: 0;
  border: 1px solid black;
}

.inputBox {
  display: inline-block;
  width: 50%;
}

.map-botton {
  text-align: center;
  line-height: 50px;
  position: absolute;
  left: 0;
  top: 50px;
  z-index: 6;
  display: flex;
  user-select: none;
}
.map-botton > div {
  cursor: pointer;
  padding: 0 10px;
  margin-right: 10px;
  border: 1px solid #cccccc;
}
.showNear {
  background-color: rgb(199, 199, 24);
}
.showAll {
  background-color: rgb(82, 122, 145);
}
</style>



// WEBPACK FOOTER //
// src/page/ChatGroup.vue